import Image from "next/image";
import Link from "next/link";
import { useRef } from "react";

import localeCore from "../../core/locale.core";
import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { Material } from "../../types/material";
import LocalePs from "../locale/localePs.core";
import { Tag } from "../reuseables/list.comp";
import DeleteMaterialDialog from "./deleteMaterialDialog.comp";

export default function MaterialListRow({ material }: { material: Material }) {
  const { selectedShop } = useShop();
  const { t, msg } = useTranslation();
  const dialogRef = useRef<HTMLDialogElement>(null);

  async function clickDelete() {
    dialogRef.current?.showModal();
  }

  if (!selectedShop) return null;

  return (
    <div
      attr-name={localeCore.getLocaleValueDefault(material.name)}
      attr-sku={material.sku}
      attr-type="product-row"
      className={`grid grid-cols-[100px_auto] lg:grid-cols-[1fr_4fr_2fr_1fr_2fr] gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm dark:text-white group/edit`}
    >
      <div className={`row-span-5 lg:row-span-2 ${!material.isActive ? "opacity-25" : ""}`}>
        {material.featureMedia ? (
          <Image
            unoptimized
            src={material.featureMedia.thumbnailUrl}
            width={100}
            height={100}
            alt={localeCore.getLocaleValueDefault(material.name) ?? ""}
          />
        ) : null}
        <div> {!material.isActive ? t(msg.general.disabled) : ""}</div>
      </div>
      <div>
        <LocalePs value={material.name} />
      </div>
      <div>
        <Tag>{t(msg.product.sku)}</Tag>
        {material.sku}
      </div>

      <div className="lg:col-span-4 flex gap-8 mt-2 opacity-0 group-hover/edit:opacity-100 transition-all">
        <Link className="product-edit cursor-pointer underline leading-8" href={`materials/edit/${material.id}`}>
          {t(msg.form.edit)}
        </Link>
        <button className="product-edit cursor-pointer underline  text-red-600" type="button" onClick={clickDelete}>
          {t(msg.form.delete)}
        </button>
        <DeleteMaterialDialog dialogRef={dialogRef} materialId={material.id} />
      </div>
    </div>
  );
}
